export function generateBreadCrumb(title = '', link = null) {
  if (link === null) return { title };
  link = link ? link : `/${title.toLowerCase()}`;
  return { title, link };
}
